<script lang="ts" setup>
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import {
  AppButton,
  SemboStarIllustration,
  SemboHeartIllustration,
} from '@libs/ui';

interface GenericHotelCardMobileProps {
  ingredientIndex: number;
}

const props = defineProps<GenericHotelCardMobileProps>();

const statsigEventsStore = useStatsigEventsStore();
const routerStore = useRouterStore();

function openHotelSelection(): void {
  statsigEventsStore.logTripOverviewAlternativeHotelsHotelSelectionCardClicked();
  routerStore.navigateToHotelSelection(props.ingredientIndex);
}
</script>

<template>
  <div class="generic-hotel-card-mobile" @click="openHotelSelection()">
    <span class="title">
      {{ $t('planner.alternative_hotels.generic_card_title') }}
    </span>
    <AppButton type="secondary" size="medium" state="enabled">
      {{ $t('planner.alternative_hotels.change_hotel') }}
    </AppButton>
    <SemboStarIllustration class="star-illustration" />
    <SemboHeartIllustration class="heart-illustration" />
  </div>
</template>

<style lang="scss" scoped>
.generic-hotel-card-mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
  width: calc(100% - 30px);
  gap: var(--spacing-24);
  background-color: var(--color-neutral-10);
  border-radius: var(--border-radius-12);
  margin-right: 0;
  overflow: hidden;

  .title {
    color: var(--color-soft-black);
    @include font-label-m-bold;
    line-height: var(--line-heights-16);
    text-align: center;
  }

  .heart-illustration {
    position: absolute;
    top: 9px;
    left: 40px;
  }
  .star-illustration {
    position: absolute;
    bottom: -18px;
    right: 25px;
  }
}
</style>
